import React, { useContext} from 'react';
import { Offcanvas } from 'react-bootstrap';
import { ContextToggle } from '../context/ContextToggle';
import Style from "./OffCanvasNav.module.css"
import Links from './Links';



const OffCanvasNav = () => {

  const links = JSON.parse(localStorage.getItem('menu'));


  const { show, handleClose } = useContext(ContextToggle);
  return (
    <>
 
      <Offcanvas show={show} onHide={handleClose} 
        className={Style.offCanvasNav_background}>
        <Offcanvas.Header closeButton>
        </Offcanvas.Header>
        <Offcanvas.Body >
        <Links links={links}></Links>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default OffCanvasNav;